// /pages/_system.js
import Swiper from 'swiper';
import 'swiper/css';

export function systemFunc() {
  document.querySelectorAll('.js-system').forEach((root) => {
    const container = root.querySelector('.swiper');
    if (!container) return;
    const wrapper   = container.querySelector('.swiper-wrapper');
    if (!wrapper) return;

    const nextEl = root.querySelector('.swiper-button-next');
    const prevEl = root.querySelector('.swiper-button-prev');

    // --- スライド直下に .p-feature-card を注入（HTML編集不要） ---
    Array.from(wrapper.children).forEach((slide) => {
      if (!slide.querySelector('.p-feature-card')) {
        const wrap = document.createElement('div');
        wrap.className = 'p-feature-card';
        while (slide.firstChild) wrap.appendChild(slide.firstChild);
        slide.appendChild(wrap);
      }
    });

    // --- 共通ユーティリティ ---
    const MQ_PC = '(min-width:768px)';
    const isPc = () => window.matchMedia(MQ_PC).matches;
    const centerIndex = () => 2;
    const snapTo = (s, idx) => s.slideTo(idx, 0, false);
    const markActiveAt = (s, idx) => {
      s.slides.forEach(el => el.classList.remove('is-active'));
      s.slides[idx]?.classList.add('is-active');
    };

    // PCの5枚レイアウト調整
    const CARD_W = 301;
    const VISIBLE_PC = 5;
    function contentWidth(el){
      const cs = getComputedStyle(el);
      return el.clientWidth - parseFloat(cs.paddingLeft||0) - parseFloat(cs.paddingRight||0);
    }
    function fitFive(s){
      const w = contentWidth(container);
      const MIN_GAP = 16;
      let gap   = Math.round((w - CARD_W * VISIBLE_PC) / (VISIBLE_PC - 1));
      let cardW = CARD_W;
      if (gap < MIN_GAP) {
        gap   = MIN_GAP;
        cardW = Math.floor((w - gap * (VISIBLE_PC - 1)) / VISIBLE_PC);
      }
      container.style.setProperty('--card-w', `${cardW}px`);
      if (s.params.slidesPerView !== 'auto') s.params.slidesPerView = 'auto';
      if (s.params.spaceBetween !== gap)     s.params.spaceBetween = gap;
      s.update();
    }

    // --- 状態 ---
    let swiper = null;
    let mode = null;
    let autoTimer = null;
    let onVis = null;
    let onNext = null;
    let onPrev = null;

    function unbindArrows(){
      if (onNext) nextEl?.removeEventListener('click', onNext), onNext = null;
      if (onPrev) prevEl?.removeEventListener('click', onPrev), onPrev = null;
    }
    function stopAuto(){
      if (autoTimer) clearInterval(autoTimer), autoTimer = null;
      if (onVis) document.removeEventListener('visibilitychange', onVis), onVis = null;
    }
    function teardown(){
      stopAuto();
      unbindArrows();
      if (swiper) {
        // true,true でクローン/スタイルもクリーンに戻す
        swiper.destroy(true, true);
        swiper = null;
      }
    }

    // --- SPセットアップ（loop:trueで滑らか自動） ---
    function setupSP(){
      mode = 'sp';
      const GAP_SP = 8;
      const AUTO_DELAY = 2800;
      const AUTO_SPEED = 600;

      swiper = new Swiper(container, {
        loop: true,
        centeredSlides: true,
        allowTouchMove: false,
        slidesPerView: 1,
        spaceBetween: GAP_SP,
        speed: AUTO_SPEED,
        initialSlide: 2,
        on: {
          slideChange: (s) => markActiveAt(s, s.activeIndex)
        }
      });

      autoTimer = setInterval(() => {
        if (document.hidden) return;
        if (swiper.animating) return;
        swiper.slideNext();
      }, AUTO_DELAY);

      // タブ非表示で一時停止
      onVis = () => {
        if (document.hidden) stopAuto();
        else if (!autoTimer) {
          autoTimer = setInterval(() => {
            if (document.hidden) return;
            if (swiper.animating) return;
            swiper.slideNext();
          }, AUTO_DELAY);
        }
      };
      document.addEventListener('visibilitychange', onVis);

      // 矢印（SPは普通に次/前へ）
      onNext = (e) => { e.preventDefault(); swiper.slideNext(); };
      onPrev = (e) => { e.preventDefault(); swiper.slidePrev(); };
      nextEl?.addEventListener('click', onNext);
      prevEl?.addEventListener('click', onPrev);
    }

    // --- PCセットアップ（5枚見せ＋中央固定、DOMローテでループ表現） ---
    function setupPC(){
      mode = 'pc';
      swiper = new Swiper(container, {
        loop: false,
        centeredSlides: true,
        allowTouchMove: false,
        slidesPerView: 'auto',
        spaceBetween: 0,
        speed: 0,
        initialSlide: centerIndex(),
        on: {
          init: (s) => {
            fitFive(s);
            snapTo(s, centerIndex());
            markActiveAt(s, centerIndex());
          },
          resize: (s) => {
            fitFive(s);
            snapTo(s, centerIndex());
            markActiveAt(s, centerIndex());
          }
        }
      });

      // PC矢印：DOMローテ → 中央にスナップ
      onNext = (e) => {
        e.preventDefault();
        const first = wrapper.firstElementChild;
        if (first) wrapper.appendChild(first);
        swiper.updateSlides(); swiper.updateProgress(); swiper.updateSlidesClasses();
        fitFive(swiper); snapTo(swiper, centerIndex()); markActiveAt(swiper, centerIndex());
      };
      onPrev = (e) => {
        e.preventDefault();
        const last = wrapper.lastElementChild;
        if (last) wrapper.insertBefore(last, wrapper.firstElementChild);
        swiper.updateSlides(); swiper.updateProgress(); swiper.updateSlidesClasses();
        fitFive(swiper); snapTo(swiper, centerIndex()); markActiveAt(swiper, centerIndex());
      };
      nextEl?.addEventListener('click', onNext);
      prevEl?.addEventListener('click', onPrev);

      // 画像ロードで幅計算
      root.querySelectorAll('img').forEach(img => {
        if (!img.complete) img.addEventListener('load', () => {
          fitFive(swiper);
          snapTo(swiper, centerIndex());
          markActiveAt(swiper, centerIndex());
        }, { once: true });
      });
    }

    // --- 初期化 & ブレークポイント跨ぎで再初期化 ---
    function boot(){
      teardown();
      if (isPc()) setupPC(); else setupSP();
    }
    boot();

    // リサイズ監視：モードが変わった時だけ再初期化
    let lastIsPc = isPc();
    window.addEventListener('resize', () => {
      const nowIsPc = isPc();
      if (nowIsPc !== lastIsPc) {
        lastIsPc = nowIsPc;
        boot();
      } else if (nowIsPc && swiper) {
        // PCのままなら幅だけ追随
        fitFive(swiper);
        snapTo(swiper, centerIndex());
        markActiveAt(swiper, centerIndex());
      }
    }, { passive: true });
  });
}
